import React from "react";
import { DateAllElement, DateSelectElement, getMonday } from "./dateElement.jsx";
export default function WeekTableDesktop(props) {
    let monday = getMonday(props.dates[0]);
    let diffDay = (d, c) => {
        d = new Date(d);
        return new Date(d.setDate(d.getDate() + c));
    }
    //.format('jS M')
    return <tbody>
        <tr className="week-heading">
            <th>Week {props.weekNo}</th>
            <th>Mon <br/> <span>{monday.format("jS")}<br/>{monday.format("M")}</span></th>
            <th>Tue <br/> <span>{diffDay(monday, 1).format("jS")}<br/>{diffDay(monday, 1).format("M")}</span></th>
            <th>Wed <br/> <span>{diffDay(monday, 2).format("jS")}<br/>{diffDay(monday, 2).format("M")}</span></th>
            <th>Thu <br/> <span>{diffDay(monday, 3).format("jS")}<br/>{diffDay(monday, 3).format("M")}</span></th>
            <th>Fri <br/> <span>{diffDay(monday, 4).format("jS")}<br/>{diffDay(monday, 4).format("M")}</span></th>
            <th className="all-header">All</th>
        </tr>
        {props.items.map(mainItem => {
            return [
                <WeekTableDesktopRow key={mainItem.id} label={mainItem.name} type={mainItem.id} dates={props.dates} />,
                mainItem.extras.map(subItem => <WeekTableDesktopRow key={subItem.id} label={subItem.name} type={subItem.id} dates={props.dates} parent={mainItem.id} />)
            ]
        })}
    </tbody>
}

function WeekTableDesktopRow(props) {
    var now = new Date();
    if(now.getHours() < 12){ //Only allow same day bookings before 6PM
        now.setDate(now.getDate() - 1);
    }
    return <tr>
        <th className={props.parent != null ? "extra-header" : ""}>{props.label}</th>
        {["Mon", "Tue", "Wed", "Thu", "Fri"].map((dLbl, idx) => <DateSelectElement key={dLbl} idx={idx} {...props} day={dLbl} now={now} />)}
        <DateAllElement {...props} now={now} type={props.type} parent={props.parent} />
    </tr>
}


// WEBPACK FOOTER //
// ./flexi/weektable/desktop.jsx